/**
 * 认证工具类
 * @author LWX
 * @date 2026-03-23
 * 修改：从 Cookie 改为 localStorage，配合 Redis token 验证
 * 修改：支持自定义 token key（内部员工 / 客户门户独立存储）
 */

const TokenKey = 'ShareWin-Token'
const TokenTimeKey = 'ShareWin-Token-Time'
const UserInfoKey = 'ShareWin-User'

/**
 * 获取 token（支持自定义key）
 * @param {string} key - 自定义key，默认使用 ShareWin-Token
 */
export function getToken(key = TokenKey) {
    return localStorage.getItem(key)
}

/**
 * 设置 token（支持自定义key）
 * @param {string} token - token值
 * @param {string} key - 自定义key，默认使用 ShareWin-Token
 */
export function setToken(token, key = TokenKey) {
    localStorage.setItem(key, token)
    if (key === TokenKey) {
        localStorage.setItem(TokenTimeKey, Date.now().toString())
    }
}

/**
 * 移除 token（支持自定义key）
 * @param {string} key - 自定义key，默认使用 ShareWin-Token
 */
export function removeToken(key = TokenKey) {
    localStorage.removeItem(key)
    if (key === TokenKey) {
        localStorage.removeItem(TokenTimeKey)
    }
}

/**
 * 获取用户信息
 */
export function getUserInfo() {
    const userInfoStr = localStorage.getItem(UserInfoKey)
    if (userInfoStr) {
        try {
            return JSON.parse(userInfoStr)
        } catch (e) {
            return null
        }
    }
    return null
}

/**
 * 设置用户信息
 */
export function setUserInfo(userInfo) {
    if (userInfo) {
        localStorage.setItem(UserInfoKey, JSON.stringify(userInfo))
    }
}

/**
 * 移除用户信息
 */
export function removeUserInfo() {
    localStorage.removeItem(UserInfoKey)
}

/**
 * 清除所有认证信息
 */
export function clearAuth() {
    removeToken(TokenKey)
    removeUserInfo()
}

/**
 * 获取 token 存储时间
 */
export function getTokenTime() {
    const timeStr = localStorage.getItem(TokenTimeKey)
    if (timeStr) {
        return parseInt(timeStr)
    }
    return null
}

/**
 * 检查 token 是否需要刷新
 */
export function shouldRefreshToken(threshold = 30 * 60 * 1000) {
    const tokenTime = getTokenTime()
    if (!tokenTime) return true
    const now = Date.now()
    return (now - tokenTime) > threshold
}